import { EVENT_MAP, TOGGLE_MOBILE } from '@/constants/navigation-events'
import { $isLoggedIn } from '@/stores/account/computed'
import { $customer } from '@/stores/account/stores'
import Alpine from 'alpinejs'

type menuTypes = 'menu' | 'submenu' | 'account'

document.addEventListener('alpine:init', () => {
  Alpine.data('navigationMobileMenu', (type) => ({
    open: false,
    loggedIn: false as boolean,
    customer: undefined as any,

    eventHandlers: {
      [`@${TOGGLE_MOBILE}.window`]() {
        if (!this.$event.detail) this.open = false
      },

      [`@${EVENT_MAP[type as menuTypes].open}`]() {
        this.loggedIn = $isLoggedIn.get()
        this.customer = $customer.get()
        this.open = true
      },

      [`@${EVENT_MAP[type as menuTypes].close}`]() {
        this.open = false
      },
    },
  }))
})
